import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 97,
	height: 48,
	viewBox: "0 0 97 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M33.6263 42.7091C37.5869 42.7091 39.8777 40.1828 39.8777 36.6718V27.466H36.2167V36.6718C36.2167 38.3203 35.2962 39.3265 33.6477 39.3265C32.0206 39.3265 31.0358 38.3203 31.0358 36.6932V27.466H27.3749V36.6932C27.3749 40.2685 29.6014 42.7091 33.6263 42.7091Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.6602 36.8002C45.6602 35.3016 46.538 34.0599 48.0794 34.0599C49.5138 34.0599 50.4986 35.1303 50.4986 36.8002C50.4986 38.4487 49.5352 39.5834 48.0794 39.5834C46.6664 39.5834 45.6602 38.5772 45.6602 36.8002ZM45.5318 31.2125H42.192V46.4556H45.7673V41.5958C46.0028 41.8741 47.0518 42.7305 48.7645 42.7305C52.0187 42.7305 54.0739 40.3113 54.0739 36.8216C54.0739 33.3748 51.8046 30.9342 48.5718 30.9342C46.9233 30.9342 45.8529 31.7263 45.5318 32.0903V31.2125Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62.2093 42.4522H65.7846V36.2222C65.7846 33.9315 65.442 30.9342 61.931 30.9342C60.518 30.9342 59.576 31.7049 59.1478 32.3686V26.9736H55.5725V42.4522H59.1478V35.7512C59.1478 34.852 59.7473 34.1455 60.7321 34.1455C61.5884 34.1455 62.2093 34.7022 62.2093 35.7512V42.4522Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M78.2303 37.7636C78.2517 37.5067 78.2517 37.2712 78.2517 37.0571C78.2517 33.225 76.3035 30.9342 72.7282 30.9342C69.4313 30.9342 67.2047 33.5675 67.2047 36.8645C67.2047 40.1828 69.4741 42.7305 73.1778 42.7305C76.0894 42.7305 77.6308 40.9107 77.952 40.2471L75.597 38.4273C75.3829 38.7484 74.5908 39.6262 73.242 39.6262C71.9147 39.6262 70.9513 38.7699 70.8656 37.7636H78.2303ZM72.7924 33.8244C73.9057 33.8244 74.5694 34.5951 74.6122 35.4943H70.9727C71.0583 34.7022 71.615 33.8244 72.7924 33.8244Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79.0789 38.9625C79.0789 41.4031 81.0486 42.7305 83.2537 42.7305C84.4098 42.7305 85.2233 42.4094 85.8013 41.8313L85.994 42.4522H89.1839V35.4943C89.1839 32.9252 88.1991 30.9342 84.3241 30.9342C82.4615 30.9342 80.9415 31.5337 79.7426 32.3258L81.07 34.7236C81.9477 34.2954 82.9111 34.0171 83.8959 34.0171C85.052 34.0171 85.6087 34.5523 85.6087 35.2374V35.6442C85.2019 35.4729 84.4312 35.2374 83.4464 35.2374C80.7917 35.2374 79.0789 36.7146 79.0789 38.9625ZM82.6542 38.8341C82.6542 38.1062 83.2965 37.6352 84.1529 37.6352C85.0092 37.6352 85.6729 38.0634 85.6729 38.8341C85.6729 39.5834 85.0306 39.9902 84.1743 39.9902C83.3393 39.9902 82.6542 39.5834 82.6542 38.8341Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M91.1146 42.4522H94.6899V26.9736H91.1146V42.4522Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 24C0 17.3726 5.37259 12 12 12H24V24C24 30.6274 18.6274 36 12 36C5.37259 36 0 30.6274 0 24Z",
			fill: "url(#paint0_linear_9222_68977)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 24C0 17.3726 5.37259 12 12 12H24V24C24 30.6274 18.6274 36 12 36C5.37259 36 0 30.6274 0 24Z",
			fill: "url(#paint1_linear_9222_68977)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 12C24 5.37259 29.3726 0 36 0C42.6274 0 48 5.37259 48 12C48 18.6274 42.6274 24 36 24H24V12Z",
			fill: "url(#paint2_linear_9222_68977)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24 12C24 5.37259 29.3726 0 36 0C42.6274 0 48 5.37259 48 12C48 18.6274 42.6274 24 36 24H24V12Z",
			fill: "url(#paint3_linear_9222_68977)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_9222_68977",
				x1: 0,
				y1: 24,
				x2: 24,
				y2: 24,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#3C6CEE" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7457FF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_9222_68977",
				x1: 12,
				y1: 36,
				x2: 12,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#98D2FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#98D2FF",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_9222_68977",
				x1: 24,
				y1: 12,
				x2: 48,
				y2: 12,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5D13AB" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#7457FF"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_9222_68977",
				x1: 43.8,
				y1: 22.8,
				x2: 33,
				y2: 6.6,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5377FF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#8053FF",
					stopOpacity: 0
				})]
			})
		] })
	]
});
export default SvgLogoFull;
